<template>
  <div>
    <v-text-field
      v-model="producto.flete"
      id="flete"
      label-for="flete"
      label="Flete"
      type="number"
      :prefix="producto.flete ? '%' : ''"
      required
      :outlined="outlined"
    ></v-text-field>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "form.producto.flete",
  inject: ["$validator"],
  components: {},
  // $_veeValidate: {
  //   validator: "new",
  // },

  props: {
    producto: {
      type: Object,
      required: true,
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

};
</script>

<style lang="scss" scoped></style>
